<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<nav class="pankuzu w-100">
							<ul class="my-4">
								<li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
								<li>  企画記事・特集一覧</li>
							</ul>
						</nav>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0">
								<h5 class="ranking_text font-weight-bold p-0 m-0">企画・特集記事 一覧</h5>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">

								<div class="card mt-3">
									<div class="card-body py-0 m-0 text-muted">

										<div class="row">
											<div class="col-md-12">

												<div class="">

												  <div class="row">
													<template v-for="(article, index) in allGetTotalArticle">
														<template v-if="index==0||index==1||index==2">
															<a @click="jumpArticleDetail(article['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
																<div class="card pt-3 px-3" style="max-width: max-content;">
																	<div class="card-img-best-parent text-center center-block" style="min-height: 160px;max-height: 160px;">
																		<img class="card-img-best" :src="article['main_image']" alt="">
																	</div>
																	<div class="card-body p-0 pt-2">
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['title'] }}</strong></span>
																			</div>
																		</div>
																		<div class="row my-1">
																			<div class="col-md-12 text-center">
																				<span class="text_3_min">{{ article['slogan'] }}</span>
																			</div>
																		</div>
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['writer_name'] }}</strong></span>
																			</div>
																		</div>
																	</div>
																</div>
															</a>
														</template>
													</template>
												  </div>

												  <div class="row">
													<template v-for="(article, index) in allGetTotalArticle">
														<template v-if="index==3||index==4||index==5">
															<a @click="jumpArticleDetail(article['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
																<div class="card pt-3 px-3" style="max-width: max-content;">
																	<div class="card-img-best-parent text-center center-block" style="min-height: 160px;max-height: 160px;">
																		<img class="card-img-best" :src="article['main_image']" alt="">
																	</div>
																	<div class="card-body p-0 pt-2">
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['title'] }}</strong></span>
																			</div>
																		</div>
																		<div class="row my-1">
																			<div class="col-md-12 text-center">
																				<span class="text_3_min">{{ article['slogan'] }}</span>
																			</div>
																		</div>
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['writer_name'] }}</strong></span>
																			</div>
																		</div>
																	</div>
																</div>
															</a>
														</template>
													</template>
												  </div>

												  <div class="row">
													<template v-for="(article, index) in allGetTotalArticle">
														<template v-if="index==6||index==7||index==8">
															<a @click="jumpArticleDetail(article['id'])" href="javascript:void(0);" class="col-md-4 center-block mb-3 mt-3" style="color: #676460;">
																<div class="card pt-3 px-3" style="max-width: max-content;">
																	<div class="card-img-best-parent text-center center-block" style="min-height: 160px;max-height: 160px;">
																		<img class="card-img-best" :src="article['main_image']" alt="">
																	</div>
																	<div class="card-body p-0 pt-2">
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['title'] }}</strong></span>
																			</div>
																		</div>
																		<div class="row my-1">
																			<div class="col-md-12 text-center">
																				<span class="text_3_min">{{ article['slogan'] }}</span>
																			</div>
																		</div>
																		<hr class="m-0">
																		<div class="row my-1">
																			<div class="col-md-12 ellipsis_text text-center">
																				<span><strong>{{ article['writer_name'] }}</strong></span>
																			</div>
																		</div>
																	</div>
																</div>
															</a>
														</template>
													</template>
												  </div>

												</div>

											</div>
										</div>


									</div>
								</div>

							</div>
						</div>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StarRating from 'vue-star-rating'

export default {
	name: 'Article',
    components: {
	  'star-rating': StarRating,
    },
	data () {
		return {
            articles: [],
		}
	},
	methods: {
      jump(number) {
        if (number==0) {
          this.$router.push({path: '/'});
        }
      },
	  jumpArticleDetail(id) {
        this.$router.push({path: '/article/list/'+String(id)});
		return false;
	  },
	  async get_article() {
		this.$store.dispatch('article/get_article_lists', {
        //   type: this.type,
        }).then(res => {
		  console.log(res);
		  let ret = res.data.articles;
		  this.articles = ret;
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },
	},
	created() {
		this.get_article();
	},
	computed: {
		allGetTotalArticle: function() {
			return this.articles;
		},
	},
}
</script>

<style scoped>
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Article.vue